import { render, staticRenderFns } from "./HorseStatistiques.vue?vue&type=template&id=f6183c74&"
import script from "./HorseStatistiques.vue?vue&type=script&lang=js&"
export * from "./HorseStatistiques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports